import { Routes } from '@angular/router'
import { authGuard } from '../shared/guards/permission.guard'

export const qcrRoutes: Routes = [
  {
    path: 'report',
    canActivate: [authGuard],
    data: {
      breadcrumb: 'routes.qcr.reports.title',
      permissionsNeeded: [],
    },
    children: [
      {
        path: 'qcr-analysis',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'routes.qcr.reports.qcrAnalysis',
          permissionsNeeded: [],
        },
        loadComponent: () => import('./pages/reports/qcr-analysis/qcr-analysis.component'),
      },
      {
        path: 'stat-variance',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'routes.qcr.reports.statVariance',
          altTitle: 'qcr.reports.statVariance.title',
          permissionsNeeded: [],
        },
        loadComponent: () => import('./pages/reports/stat-variance/stat-variance.component'),
      },
      {
        path: 'controlables-qcr',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'routes.qcr.reports.controlablesQcr',
          altTitle: 'qcr.reports.controlablesQcr.title',
          permissionsNeeded: [],
        },
        loadComponent: () => import('./pages/reports/controlables-qcr/controlables-qcr.component'),
      },
      {  
        path: 'base-cost',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'routes.qcr.reports.baseCost',
          permissionsNeeded: [],
        },
        loadComponent: () => import('./pages/reports/base-cost/base-cost.component'),
      },
    ]
  }
]
